import { gql } from '@apollo/client';

export const FILTERED_HIERARCHIY_LEVELS = gql`
  query FilteredHierarchyLevels($input: AllHierarchyLevelsInput!) {
    hierarchyLevels: filteredHierarchyLevels(input: $input) {
      aggregate {
        count
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
      edges {
        node {
          id
          value
          typeOfSite
          hasSubtypes
          subtypes
        }
      }
    }
  }
`;
